const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/packages.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { TbX } from "react-icons/tb";
export const Route = createFileRoute("/_app/packages")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface PackageFormData {
  name: string;
  description: string;
  price: number;
  quantity: number;
  is_active: boolean;
}
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}